<div class="production-fabrication-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">
    <div class="form-section">
      <div class="two-col-grid">
        <nz-form-item>
          <nz-form-label>Event Structures</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              formControlName="event_structures"
              nzPlaceHolder="Select event structures"
              nzMode="multiple"
            >
              <nz-option
                *ngFor="let v of eventStructuresResponseModel.value.results"
                [nzValue]="v.id"
                [nzLabel]="v.name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Infrastructure</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              formControlName="infrastructure"
              nzPlaceHolder="Select infrastructure"
              nzMode="multiple"
            >
              <nz-option
                *ngFor="let v of infrastructureResponseModel.value.results"
                [nzValue]="v.id"
                [nzLabel]="v.name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Live Streaming & Hybrid</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              formControlName="live_streaming_hybrid"
              nzPlaceHolder="Select live streaming & hybrid"
              nzMode="multiple"
            >
              <nz-option
                *ngFor="let v of liveStreamingHybridResponseModel.value.results"
                [nzValue]="v.id"
                [nzLabel]="v.name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Intercom & Communication</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              formControlName="intercom_communication"
              nzPlaceHolder="Select intercom & communication"
              nzMode="multiple"
            >
              <nz-option
                *ngFor="let v of intercomCommunicationResponseModel.value.results"
                [nzValue]="v.id"
                [nzLabel]="v.name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </form>
</div>
